<table>
  <ng-content></ng-content>
</table>
